export const BRAND_VISIBLE_INACTIVE_REASON = 'temp'

export const isBrandArchived = (brand) => brand?.isArchived === true

export const isBrandHiddenInSpoiler = (brand) => {
  if (brand?.isArchived === true) {
    return true
  }

  if (brand?.isActive === true) {
    return false
  }

  return brand?.inactiveReason !== BRAND_VISIBLE_INACTIVE_REASON
}

export const splitBrandsByArchive = (brands = []) => ({
  active: brands.filter((brand) => !isBrandHiddenInSpoiler(brand)),
  archived: brands.filter(isBrandHiddenInSpoiler),
})
